export function Logo() {
  return (
    <div className={"flex items-center space-x-3"}>
      <img className={"h-10"} src={"/logo.png"} alt={"Norma's teaching"} />
      <h4 className={"font-bold text-lg"}>Norma's Teaching</h4>
    </div>
  );
}
